import styled from '@emotion/styled'

import colors from '../../design/color-names.js'

import { shouldForwardProp } from '../../helpers/styled.ts'

interface SortableListStageItemProps {
  isDragging?: boolean
  isPlaceholder?: boolean
}

export const SortableListContainer = styled.div`
  label: sortable-list-container;
  position: relative;
`

export const SortableListStage = styled.div`
  label: sortable-list-stage;

  display: flex;
  flex-direction: column;
  gap: 0;
`

export const SortableListStageContentWrapper = styled.div`
  label: sortable-list-stage-content-wrapper;
  min-width: 0;
`

export const SortableListStageItem = styled('div', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<SortableListStageItemProps>(
      ['isDragging', 'isPlaceholder'],
      prop,
    ),
})<SortableListStageItemProps>`
  label: sortable-list-stage-item;

  border-radius: 6px;
  padding: 8px 16px;

  display: grid;
  grid-template-columns: 16px auto;
  gap: 16px;

  &:hover {
    background-color: ${colors.wildSand};
  }

  ${({ isDragging }) =>
    isDragging === true
      ? `
        border: 1px solid ${colors.geyser}; 
        background-color: #fff !important; 
        box-shadow: 0 2px 2px 0 #83838333;
        cursor: grab !important;

        input {
          pointer-events:none;
        }

        `
      : ''}

  ${({ isPlaceholder }) =>
    isPlaceholder === true
      ? `
        border: 1px solid ${colors.geyser};
        background-color: ${colors.wildSand}; 

        `
      : ''}
`

export const SortableListStageItemPlaceholder = styled.div`
  label: sortable-list-stage-item-placeholder;

  height: 52px;

  border-radius: 6px;
  padding: 8px 16px;

  display: grid;
  grid-template-columns: 16px auto;
  gap: 16px;

  background-color: ${colors.wildSand};
`

export const SortableListStageHandleWrapper = styled.div`
  label: sortable-list-stage-handle-wrapper;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 36px;

  color: ${colors.boulder};

  cursor: grab;

  &[role='button'][tabindex='0'] {
    outline: none;
  }
`
